<template>
  <v-card class="ma-0" width="100%" style="height: auto" elevation="2">
    <v-app-bar flat class="my-0 py-1 mb-2 px-4" dense height="30">
      <v-toolbar-title>{{ $t($route.name) }}</v-toolbar-title>
      <v-spacer />
      <v-btn
        v-shortkey="['f5']"
        color="success"
        outlined
        class="mt-2 me-2"
        small
        :loading="loading"
        @click="getReportExcel"
      >
        {{ $t("get-report-excel") }}
      </v-btn>
      <v-btn
        v-shortkey="['f5']"
        color="primary"
        outlined
        class="mt-2"
        small
        :loading="loading"
        @shortkey="getItems"
        @click="getItems"
      >
        {{ $t("getReport") }}
      </v-btn>
    </v-app-bar>
    <v-progress-linear
      :active="loading"
      :indeterminate="loading"
      absolute
      bottom
      style="top: -4px"
      color="primary"
    />
    <v-row class="mt-1">
      <v-col class="d-flex py-0">
        <v-col cols="12" md="2">
          <v-select
            v-model="balance"
            :label="$t('balanceType')"
            :items="balanceItems"
            height="32"
            dense
            outlined
            hide-details
            item-value="value"
            item-text="text"
          />
        </v-col>
        <v-col cols="12" md="2">
          <v-select
            v-model="remain"
            :label="$t('remainType')"
            :items="remainItems"
            height="32"
            dense
            outlined
            hide-details
            item-value="value"
            item-text="text"
          />
        </v-col>
        <v-col cols="12" md="2">
          <v-select
            v-model="priority"
            :label="$t('priorityAccount')"
            :items="priorityItems"
            height="32"
            dense
            outlined
            hide-details
            item-value="value"
            item-text="text"
          />
        </v-col>
        <v-col cols="12" md="2">
          <autocomplete
            v-model="fromFinancialYear"
            :title="$t('fromFinancialYear')"
            type="year"
            :value="fromFinancialYear"
          />
        </v-col>
        <v-col cols="12" md="2">
          <autocomplete
            v-model="toFinancialYear"
            :title="$t('toFinancialYear')"
            type="year"
            :value="toFinancialYear"
          />
        </v-col>
        <v-col cols="12" md="2">
          <tag v-model="tag" :solo="false" :input="tag" :height="25" />
        </v-col>
      </v-col>
    </v-row>
    <v-row class="mt-6">
      <v-col class="d-flex py-0">
        <v-col cols="12" md="2" class="pt-0">
          <v-select
            v-model="filterType"
            :label="$t('filter')"
            :items="filterTypeItems"
            height="32"
            dense
            outlined
            hide-details
            item-value="value"
            item-text="text"
          />
        </v-col>
        <v-col v-show="filterType == 'month'" cols="12" md="2" class="pt-0">
          <template>
            <v-text-field
              id="fromIdMonth"
              v-model="fromMonth"
              :label="$t('from') + ' ' + $t('month')"
              outlined
              dense
              clearable
            />
            <date-picker
              v-model="fromMonth"
              element="fromIdMonth"
              locale="fa,en"
              auto-submit
              type="year-month"
              format="jYYYY/jMM"
              :min="fromFinancialYear ? fromFinancialYear.start_date : null"
              :max="toFinancialYear ? toFinancialYear.end_date : null"
              simple
              :color="
                this.$vuetify.theme.themes[this.$vuetify.theme.isDark ? 'dark' : 'light']
                  .primary
              "
            />
          </template>
        </v-col>
        <v-col v-show="filterType == 'month'" cols="12" md="2" class="pt-0">
          <template>
            <v-text-field
              id="toIdMonth"
              v-model="toMonth"
              :label="$t('until') + ' ' + $t('month')"
              outlined
              dense
              clearable
            />
            <date-picker
              v-model="toMonth"
              element="toIdMonth"
              locale="fa,en"
              auto-submit
              type="year-month"
              format="jYYYY/jMM"
              :min="fromFinancialYear ? fromFinancialYear.start_date : null"
              :max="toFinancialYear ? toFinancialYear.end_date : null"
              simple
              :color="
                this.$vuetify.theme.themes[this.$vuetify.theme.isDark ? 'dark' : 'light']
                  .primary
              "
            />
          </template>
        </v-col>
        <v-col v-show="filterType == 'date'" cols="12" md="2" class="pt-0">
          <template>
            <v-text-field
              id="fromId"
              v-model="fromDate"
              :label="$t('from') + ' ' + $t('date')"
              outlined
              dense
              clearable
            />

            <date-picker
              v-model="fromDate"
              element="fromId"
              :locale="$store.state.date_locale"
              :format="$store.state.date_format"
              auto-submit
              :color="
                this.$vuetify.theme.themes[this.$vuetify.theme.isDark ? 'dark' : 'light']
                  .primary
              "
              @close="setDate"
            />
          </template>
        </v-col>
        <v-col v-show="filterType == 'date'" cols="12" md="2" class="pt-0">
          <template>
            <v-text-field
              id="toId"
              v-model="toDate"
              :label="$t('until') + ' ' + $t('date')"
              outlined
              dense
              clearable
            />

            <date-picker
              v-model="toDate"
              element="toId"
              :locale="$store.state.date_locale"
              :format="$store.state.date_format"
              :min="fromDate"
              auto-submit
              :color="
                this.$vuetify.theme.themes[this.$vuetify.theme.isDark ? 'dark' : 'light']
                  .primary
              "
              @close="setDate"
            />
          </template>
        </v-col>
        <v-col cols="12" md="2" class="pt-0">
          <v-text-field
            v-model="fromNum"
            height="20"
            dense
            outlined
            class="dense"
            clearable
            :label="$t('from-number')"
            ref="number"
          />
        </v-col>
        <v-col cols="12" md="2" class="pt-0">
          <v-text-field
            v-model="toNum"
            height="20"
            dense
            outlined
            class="dense"
            clearable
            :label="$t('toNumber')"
            ref="number"
          />
        </v-col>
        <v-col cols="12" md="2" class="pt-0">
          <autocomplete
            v-model="branch"
            title="branch"
            type="branch"
            :filter="true"
            :multiple="true"
          />
        </v-col>
      </v-col>
    </v-row>
    <v-row class="mt-3">
      <v-col class="d-flex py-0">
        <v-col cols="12" md="2">
          <autocomplete
            v-model="documentType"
            :title="$t('documentType')"
            type="documentType"
            :filter="true"
            :multiple="true"
          />
        </v-col>
        <v-col cols="12" md="2" class="pt-0">
          <v-checkbox
            color="primary"
            v-model="closing_doc_status"
            :label="$t('report without closing document')"
          >
          </v-checkbox>
        </v-col>
        <v-col cols="12" md="2" class="pt-0">
          <v-checkbox
            color="primary"
            v-model="opening_doc_status"
            :label="$t('report without opening document')"
          >
          </v-checkbox>
        </v-col>
        <v-col cols="12" md="2" class="pt-0">
          <v-checkbox
            color="primary"
            v-model="temperory_doc_status"
            :label="$t('report without temporary document')"
          >
          </v-checkbox>
        </v-col>
      </v-col>
    </v-row>
    <v-row class="mx-0">
      <v-col class="pb-2 px-2" cols="12">
        <print :data-prop="data" :report-prop="reportName" :resource-prop="reportName" />
      </v-col>
    </v-row>
    <v-row />
    <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="deletDialog"
      width="400"
    >
      <v-card>
        <v-col>
          <v-btn icon class="close-hover" @click="deletDialog = false">
            <v-icon color="grey" large> mdi-close </v-icon>
          </v-btn>
        </v-col>
        <v-col>
          <v-img class="mx-auto" width="200" src="@/assets/stop.svg" />
        </v-col>
        <v-col class="mt-3 pr-7">
          <p class="mx-auto font-weight-medium">
            {{ $t("are-you-sure-delete-this-case") }}
          </p>
        </v-col>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col cols="6">
              <v-btn v-if="selected.length > 0" color="primary">
                {{ $t("remove") }}
              </v-btn>
              <v-btn v-if="selected.length == 0" color="primary">
                {{ $t("remove") }}
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                color="grey"
                outlined
                class="float-left"
                @click="deletDialog = false"
              >
                {{ $t("cancel") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--    upload dialog-->
    <v-snackbar
      v-model="snakbar"
      :color="snakbarColor ? snakbarColor : ''"
      top
      style="z-index: 1000000000000 !important"
    >
      {{ snakbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snakbar = !snakbar">
          {{ $t("close") }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-card>
</template>

<script>
import General from "../../../../Mixins/general";
// import { AgGridVue } from 'ag-grid-vue'
import AG_GRID_LOCALE_EN from "../../../../locales/fa.json";
import print from "./../../components/general/printViewer/printViewer";
export default {
  name: "accountingBalance",
  components: {
    print,
    // AgGridVue,
  },
  mixins: [General],
  props: [],
  data: () => ({
    selected: [],
    filterType: "month",
    filterTypeItems: null,
    fromFinancialYear: null,
    toFinancialYear: null,
    remain: "debtorCreditor",
    remainItems: [],
    year: null,
    balance: "4columns",
    fromMonthDisplay: null,
    documentType: null,
    totalAccount: null,
    balanceItems: null,
    category: null,
    integratorType: null,
    rangeDate: null,
    registerar: null,
    attractionMethod: null,
    toDate: null,
    fromDate: null,
    fromMonth: null,
    fromMonthItems: null,
    toMonthItems: null,
    toMonth: null,
    printDialog: false,
    uploadDialog: false,
    accountDialog: false,
    deletDialog: false,
    filter: false,
    financialStatus: null,
    customerStatus: null,
    status: "active",
    taskindex: 0,
    lead: null,
    refId: null,
    taskItem: null,
    model: null,
    from: 1,
    taskDialog: null,
    taskDialogList: null,
    showSelect: null,
    tag: null,
    temp: null,
    sellStatus: null,
    items: [],
    sortBy: [],
    data: null,
    dialog: null,
    timer: 0,
    totalItems: 0,
    snakbar: false,
    snakbarText: null,
    loading: false,
    options: {
      itemsPerPage: 5,
    },
    deleteItem: null,
    headers: null,
    personnel: null,
    search: null,
    renderTable: null,
    selectedHeaders: [],
    columnDefs: null,
    rowData: null,
    gridApi: null,
    localeText: null,
    reportName: null,
    priorityItems: [],
    priority: "total",
    closing_doc_status: false,
    opening_doc_status: false,
    temperory_doc_status: false,
    documentTypeItems: null,
    fromNum: null,
    toNum: null,
  }),
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.name === "xs";
    },
    showHeaders() {
      var app = this;
      return this.headers.filter(function (s) {
        return app.selectedHeaders.includes(s);
      });
    },
    // totals: function () {
    // var app = this
    // app.excelItems = []
    // const totals = this.items.reduce((acc, d, index) => {
    //   acc.amount += parseFloat((d.remain ? d.remain : 0))
    //   app.excelItems.push({
    //     row: +index + +1,
    //     // name: String(d.name),
    //     // category: (d.category ? d.category.name : ''),
    //     // phone: (d.phone ? String(d.phone) : ''),
    //   })
    //   return acc
    // }, {
    //   amount: 0,
    // })
    // app.renderTable = true
    // return totals
    // },
  },
  watch: {
    closing_doc_status: {
      handler(val) {
        if (this.documentTypeItems && this.documentTypeItems.length > 0) {
          //add both check box condition together
          this.DocumentTypeCheckboxs();
        }
      },
      deep: true,
    },
    opening_doc_status: {
      handler(val) {
        if (this.documentTypeItems && this.documentTypeItems.length > 0) {
          //add both check box condition together
          this.DocumentTypeCheckboxs();
        }
      },
      deep: true,
    },
    temperory_doc_status: {
      handler(val) {
        if (this.documentTypeItems && this.documentTypeItems.length > 0) {
          //add both check box condition together
          this.DocumentTypeCheckboxs();
        }
      },
      deep: true,
    },
    documentType(val) {
      if (val == "closingDocument") {
        this.closing_doc_status = false;
      }
      if (val == "initial") {
        this.opening_doc_status = false;
      }
      if (val == "closingTemporaryAccountsDocument") {
        this.temperory_doc_status = false;
      }
    },
    // search () {
    //   var app = this
    //   app.loading = true
    //   clearTimeout(this.timer)
    //   this.timer = setTimeout(function () {
    //     app.getItems()
    //   }, 1000)
    // },
  },
  created() {
    this.localeText = AG_GRID_LOCALE_EN;
  },
  activated() {
    // this.getItems()
  },
  beforeMount() {
    this.balanceItems = [
      {
        value: "2columns",
        text: this.$t("2columns"),
      },
      {
        value: "4columns",
        text: this.$t("4columns"),
      },
      {
        value: "6columns",
        text: this.$t("6columns"),
      },
      {
        value: "8columns",
        text: this.$t("8columns"),
      },
    ];
    this.priorityItems = [
      {
        value: "total",
        text: this.$t("total"),
      },
      {
        value: "given",
        text: this.$t("given"),
      },
      {
        value: "detail",
        text: this.$t("detail"),
      },
      {
        value: "totalGivenDetail",
        text: this.$t("total") + "/" + this.$t("given") + "/" + this.$t("detail"),
      },
      {
        value: "totalGiven",
        text: this.$t("total") + "/" + this.$t("given"),
      },
      {
        value: "givenDetail",
        text: this.$t("given") + "/" + this.$t("detail"),
      },
    ];
    this.remainItems = [
      {
        value: "debtorCreditor",
        text: this.$t("debtor") + " " + this.$t("creditor"),
      },
      {
        value: "debtor",
        text: this.$t("debtor"),
      },
      {
        value: "creditor",
        text: this.$t("creditor"),
      },
      {
        value: "zero",
        text: this.$t("zero"),
      },
    ];
    this.filterTypeItems = [
      {
        value: "month",
        text: this.$t("month"),
      },
      {
        value: "date",
        text: this.$t("date"),
      },
    ];
  },
  mounted() {
    this.headersMap = this.headers;
    this.selectedHeaders = this.headers;
    this.fromFinancialYear = this.$store.state.financialYear;
    this.toFinancialYear = this.$store.state.financialYear;
    this.fetchDocList();
  },
  methods: {
    DocumentTypeCheckboxs() {
      if (!this.documentTypeItems?.length) return;
      const arrayCheckboxID = [];
      if (this.closing_doc_status) arrayCheckboxID.push("closingDocument");
      if (this.opening_doc_status) arrayCheckboxID.push("initial");
      if (this.temperory_doc_status)
        arrayCheckboxID.push("closingTemporaryAccountsDocument");
      if (arrayCheckboxID.length === 0) {
        this.documentType = [];
      } else {
        this.documentType = this.documentTypeItems.filter(
          (item) => !arrayCheckboxID.includes(item.id)
        );
      }
    },
    fetchDocList() {
      var app = this;
      app.$axios
        .get(this.$endpoint + "getdetail", {
          params: {
            select: "documentType",
            page: 1,
            currency: 2746,
          },
        })
        .then((r) => {
          app.documentTypeItems = r.data.data;
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        })
        .finally(() => (app.loading = false));
    },
    edit(item) {
      this.$router.push({ name: "customerEdit", params: { id: item.id } });
    },
    getReportExcel() {
      var app = this;
      app.loading = true;
      app.$axios
        .get(this.$endpoint + "accountingreport", {
          params: {
            search: app.search,
            branch: app.branch,
            remain: app.remain,
            documentType: app.documentType,
            priority: app.priority,
            balance: app.balance,
            page: app.options.page,
            fromFinancialYear: app.fromFinancialYear ? app.fromFinancialYear.id : null,
            toFinancialYear: app.toFinancialYear ? app.toFinancialYear.id : null,
            fromMonth: app.fromMonth,
            toMonth: app.toMonth,
            fromDate: app.fromDate,
            toDate: app.toDate,
            report: "balance",
            sortBy: app.sortBy,
            options: app.options,
            totalAccount: app.totalAccount,
            tag: app.tag,
            fileReport: "active",
          },
          responseType: "arraybuffer",
        })
        .then((response) => {
          // create a blob from response
          const blob = new Blob([response.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });

          // create a link element
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);

          // set file name
          link.download = "balance.xlsx";

          // trigger download
          link.click();

          // cleanup
          window.URL.revokeObjectURL(link.href);
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        })
        .finally(() => (app.loading = false));
    },
    getItems() {
      var app = this;
      app.loading = true;
      app.$axios
        .get(this.$endpoint + "accountingreport", {
          params: {
            search: app.search,
            branch: app.branch,
            remain: app.remain,
            documentType: app.documentType,
            priority: app.priority,
            balance: app.balance,
            page: app.options.page,
            fromFinancialYear: app.fromFinancialYear ? app.fromFinancialYear.id : null,
            toFinancialYear: app.toFinancialYear ? app.toFinancialYear.id : null,
            fromMonth: app.fromMonth,
            toMonth: app.toMonth,
            fromDate: app.fromDate,
            fromNumber: app.fromNum,
            toNumber: app.toNum,
            toDate: app.toDate,
            report: "balance",
            sortBy: app.sortBy,
            options: app.options,
            totalAccount: app.totalAccount,
            tag: app.tag,
          },
        })
        .then((res) => {
          res = res.data;
          app.data = res;
          if (
            app.priority === "totalGivenDetail" ||
            app.priority === "totalGivenDetail"
          ) {
            app.reportName = "balance" + app.balance + "-tgd";
          }
          if (app.priority === "totalGiven") {
            app.reportName = "balance" + app.balance + "-tg";
          }
          if (
            app.priority === "total" ||
            app.priority === "given" ||
            app.priority === "detail"
          ) {
            app.reportName = "balance" + app.balance;
          }
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        })
        .finally(() => (app.loading = false));
    },
    onFilterTextBoxChanged() {
      this.gridApi.setQuickFilter(document.getElementById("filter-text-box").value);
    },
    onBtExport() {
      this.gridApi.exportDataAsExcel();
    },
    onGridReady(params) {
      this.gridApi = params.api;
      // this.gridColumnApi = params.columnApi
      //
      // const updateData = (data) => {
      //   this.rowData = data
      // }
      //
      // fetch('https://www.ag-grid.com/example-assets/small-olympic-winners.json')
      //   .then((resp) => resp.json())
      //   .then((data) => updateData(data))
    },
  },
};
</script>
<style scoped>
.v-input--selection-controls {
  padding-top: 0;
}
::v-deep .v-input--selection-controls__ripple {
  display: none !important;
}
.ag-theme-alpine {
  --ag-grid-size: 3px !important;
  --ag-list-item-height: 20px !important;
}
.v-badge__badge {
  height: 16px !important;
  min-width: 16px !important;
  padding: 4px 6px !important;
}
.v-data-table > .v-data-table__wrapper .v-data-table__mobile-row {
  height: initial;
  min-height: 32px !important;
}
</style>
